import { MutableRefObject, useCallback, useRef } from "react";
import findIndex from "../helpers/findIndex";
import { KeyExtractor, OnActiveItem } from "../types";

const useProcessNewActiveItem = <TItem>({
	dataRef,
	keyExtractor,
	curKey,
	curIndex,
	onActiveItem,
}: {
	dataRef: MutableRefObject<TItem[]>;
	keyExtractor: KeyExtractor<TItem>;
	curKey: MutableRefObject<string>;
	curIndex: MutableRefObject<number>;
	onActiveItem: OnActiveItem<TItem> | undefined;
}) => {
	const prevCalled = useRef<null | string>(null);
	const processNewActiveItem = useCallback(() => {
		if (!onActiveItem) return;
		if (prevCalled.current === curKey.current) return;
		prevCalled.current = curKey.current;
		const index = findIndex({
			data: dataRef.current,
			keyExtractor,
			targetKey: curKey.current,
			prevIndex: curIndex.current,
		});
		const item = dataRef.current[index];
		if (item) {
			onActiveItem?.({ item });
		}
	}, [keyExtractor, onActiveItem, curKey, curIndex, dataRef]);
	return processNewActiveItem;
};
export default useProcessNewActiveItem;
